define('services/myservices/myservice-package.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('myServicesPackage', ['$rootScope', '$http', '$q', '$filter', 'ngDialog', 'OpenApp', 'auiDialog', 'auiUpload', 'auiSpliceUpload', 'appClaimsService', 'auiAgreementHelper', '$timeout',
        function ($rootScope, $http, $q, $filter, ngDialog, OpenApp, auiDialog, auiUpload, auiSpliceUpload, appClaimsService, auiAgreementHelper, $timeout) {
            var getPackageListApiMap = mainCons.myservicePackage.getPackageListApi;
            var getPackageListApiParamMap = mainCons.myservicePackage.getPackageListApiParam;
            var uploadPkgMap = mainCons.myservicePackage.uploadPkg;
            var packageIsFirstFinishedMap = mainCons.myservicePackage.packageIsFirstFinished;
            var packageIsUpdateFinishedMap = mainCons.myservicePackage.packageIsUpdateFinished;
            var prodTypeAutoDelete = mainCons.myservicePackage.prodTypeAutoDelete;
            //新建产品的HTML
            var newProductHtmlMap = mainCons.myservicePackage.newProductHtml;
            //需要默认添加服务的服务
            var needAutoAddSerMap = mainCons.myservicePackage.needAutoAddSer;

            //获取包的列表
            function getPackageList(product) {
                var defer = $q.defer();
                var prodType = (product.prodType + "").split("-")[0];
                var params = {};
                params.request = {};
                params.request[$filter('auiMapWithDefault')($filter('auiMapWithDefault')(prodType, getPackageListApiMap), getPackageListApiParamMap)] = product.prodID;
                params.request.maxReqCount = 100;
                OpenApp[$filter('auiMapWithDefault')(prodType, getPackageListApiMap)](params).then(function (res) {
                    defer.resolve(res)
                }).catch(function (res) {
                    defer.reject(res);
                });
                return defer.promise;
            }


            //下一步
            function nextStep(Model) {
                var defer = $q.defer();
                var isNotFinisheds = [];
                var packageIsFinishedCfg = {};
                if (Model.product && Model.product.prodType) {
                    if (Model.isUpdate) {
                        packageIsFinishedCfg = $filter('auiMapWithDefault')(Model.product.prodType, packageIsUpdateFinishedMap);
                    } else {
                        packageIsFinishedCfg = $filter('auiMapWithDefault')(Model.product.prodType, packageIsFirstFinishedMap);
                    }
                    for (var key in packageIsFinishedCfg) {
                        //只遍历对象自身的属性，而不包含继承于原型链上的属性。
                        if (Object.prototype.hasOwnProperty.call(packageIsFinishedCfg, key) === true) {
                            if (!Model.selected[packageIsFinishedCfg[key]]) {
                                isNotFinisheds.push(packageIsFinishedCfg[key])
                            }
                        }
                    }
                } else {
                    auiDialog.warn("请选择产品类型");
                }
                defer.resolve(isNotFinisheds);
                return defer.promise;
            }


            //创建产品
            function newProduct(modelParam, UserInfoPreload) {
                var defer = $q.defer();
                var newProductCfg = $filter('auiMapWithDefault')(modelParam.selected.prodType, newProductHtmlMap);
                var createCountry = UserInfoPreload.nationalCode || 'CN';
                if ((modelParam.selected.prodType == "1" || modelParam.selected.prodType == "8" || modelParam.selected.prodType == "2" || modelParam.selected.prodType == "27") && AUI.BaseJSUtil.contains(UserInfoPreload.whiteList, mainCons.whiteRightidDetailConstant.automaticPublishInternal)) {
                    if (modelParam.selected.prodType == 8) {
                        auiAgreementHelper.checkAgreement(48).then(function (result) {
                            if (result.signed) {
                                automaticPublishAddProduct(modelParam, UserInfoPreload, createCountry).then(function (res) {
                                    defer.resolve(res)
                                }).catch(function () {
                                    defer.reject();
                                });
                            }
                        });
                    } else {
                        automaticPublishAddProduct(modelParam, UserInfoPreload, createCountry).then(function (res) {
                            defer.resolve(res)
                        }).catch(function () {
                            defer.reject();
                        });
                    }

                } else {
                    if (modelParam.selected.prodType == 8) {
                        auiAgreementHelper.checkAgreement(48).then(function (result) {
                            if (result.signed) {
                                addPublicProduct(newProductCfg, createCountry, UserInfoPreload, modelParam).then(function (res) {
                                    defer.resolve(res)
                                });
                            }
                        })
                    } else {
                        addPublicProduct(newProductCfg, createCountry, UserInfoPreload, modelParam).then(function (res) {
                            defer.resolve(res)
                        });
                    }
                }

                return defer.promise;
            }

            //正常创建产品
            function addPublicProduct(newProductCfg, createCountry, UserInfoPreload, modelParam) {
                var defer = $q.defer();
                ngDialog.open({
                    template: newProductCfg.tempHtml,
                    className: '',
                    controller: ['$scope', function ($scopeDlg) {

                        var Model = $scopeDlg.Model = {};
                        Model.needParentType = true;
                        Model.productName = newProductCfg.productName;
                        $scopeDlg.prodRegex = mainCons.servicesConstant.regexp.fontDynamicName;
                        //应用类型的选择 服务是游戏时，应用类型只有游戏
                        if (modelParam.serviceItem == 52) {
                            Model.parentType = angular.copy([
                                {key: "2", value: "游戏"}
                            ]);
                            Model.parentTypeSelected = Model.parentType[0];
                        } else {
                            Model.parentType = angular.copy(newProductCfg.parentType);
                        }
                        if (modelParam.selected.prodType == "23") {
                            Model.parentTypeSelected = Model.parentType[0];
                        }
                        //根据华为钱包要求，确定是否展示父类型
                        if (modelParam.needParentType === false) {
                            Model.needParentType = false;
                            Model.parentTypeSelected = Model.parentType[0];
                        }
                        //应用语言选择
                        Model.languageList = angular.copy(newProductCfg.languageList);
                        if (Model.languageList.length == 1) {
                            Model.languageSelected = Model.languageList[0];
                        }
                        if (modelParam.selected.prodType == 20 || modelParam.selected.prodType == 17) { //动态壁纸和字体默认选择中文
                            Model.languageSelected = Model.languageList[0];
                        }
                        $scopeDlg.commit = function () {
                            var defertemp = $q.defer();
                            if ($scopeDlg.appForm.$invalid) {
                                $scopeDlg.appForm.$setDirty();
                                for (var key in $scopeDlg.appForm) {
                                    //只遍历对象自身的属性，而不包含继承于原型链上的属性。
                                    if ((Object.prototype.hasOwnProperty.call($scopeDlg.appForm, key) === true) && key.indexOf('$') < 0) {
                                        $scopeDlg.appForm[key].$setDirty();
                                    }
                                }
                                defertemp.resolve();
                                return defertemp.promise;
                            } else {
                                Model[newProductCfg.addProduct]().then(function (res) {
                                    defertemp.resolve();
                                    defer.resolve(res);
                                }).catch(function (res) {
                                    defertemp.resolve();
                                });
                            }
                            return defertemp.promise;
                        };
                        $scopeDlg.cancel = function () {
                            ngDialog.close();
                        };

                        Model.addApp = function () {
                            var defer = $q.defer();
                            var params = {
                                request: {
                                    appName: $scopeDlg.appName,
                                    defaultLang: Model.languageSelected.key,
                                    parentType: Model.productName === 'IOS移动应用' ? "22" : Model.parentTypeSelected.key,
                                    prodType: modelParam.selected.prodType,
                                    createCountry: createCountry
                                }
                            };
                            addAppFun(params, UserInfoPreload, modelParam, Model, true).then(function (res) {
                                defer.resolve(res);
                            });
                            return defer.promise;
                        };
                        Model.addFreeApp = function () {
                            var defer = $q.defer();
                            var params = {
                                request: {
                                    appName: $scopeDlg.appName,
                                    defaultLang: Model.languageSelected.key,
                                    parentType: Model.parentTypeSelected.key,
                                    prodType: modelParam.selected.prodType.split('-')[0],
                                    createCountry: createCountry,
                                    freeInstallType: modelParam.selected.prodType.split('-')[1]
                                }
                            };
                            addAppFun(params, UserInfoPreload, modelParam, Model, true).then(function (res) {
                                defer.resolve(res);
                            });
                            return defer.promise;
                        };

                    }]

                });
                return defer.promise;
            }

            //自动发布创建产品
            function automaticPublishAddProduct(modelParam, UserInfoPreload, createCountry) {
                var defer = $q.defer();
                var handle = ngDialog.open({
                    template: 'pages/myservices/common/automatic-publish-product.html',
                    className: '',
                    controller: ['$scope', function ($scopeDlg) {
                        var Model = $scopeDlg.Model = {
                            appName: '',
                            packageName: ''
                        };
                        //标题名称 1 2 8 27
                        Model.productName = newProductHtmlMap[modelParam.selected.prodType].productName;
                        //应用类型的选择
                        Model.parentType = mainCons.myservicePackage.parentType;
                        if (modelParam.serviceItem == 52) {
                            Model.parentType = angular.copy([
                                {key: "2", value: "游戏"}
                            ]);
                            Model.parentTypeSelected = Model.parentType[0];
                        }
                        //语言类型的选择
                        Model.languageList = newProductHtmlMap[modelParam.selected.prodType].languageList;
                        $scopeDlg.appDetail = function () {
                            var defertemp = $q.defer();
                            if ($scopeDlg.appForm.$invalid) {
                                $scopeDlg.appForm.$setDirty();
                                for (var key in $scopeDlg.appForm) {
                                    //只遍历对象自身的属性，而不包含继承于原型链上的属性。
                                    if (Object.prototype.hasOwnProperty.call($scopeDlg.appForm, key) === true && key.indexOf('$') < 0) {
                                        $scopeDlg.appForm[key].$setDirty()
                                    }
                                }
                                defertemp.resolve();
                                return defertemp.promise;
                            } else {
                                var params = {
                                    request: {
                                        appName: $scopeDlg.appName,
                                        defaultLang: Model.languageSelected.key,
                                        parentType: Model.parentTypeSelected.key,
                                        prodType: modelParam.selected.prodType,
                                        createCountry: createCountry,
                                        packageName: Model.packageName
                                    }
                                };
                                addAppFun(params, UserInfoPreload, modelParam, Model, false).then(function (res) {
                                    if (res) res.packageName = Model.packageName;
                                    defer.resolve(res);
                                    defertemp.resolve(res);
                                    handle.close();
                                }).catch(function (res) {
                                    defertemp.reject(res);
                                });
                            }
                            return defertemp.promise;
                        };
                        $scopeDlg.cancel = function () {
                            handle.close();
                        };
                    }]
                });
                return defer.promise;
            }


            function updateAPP(gAppInfo, serviceItem) {
                var defer = $q.defer();
                var params = {request: {appInfo: gAppInfo, serviceItem: serviceItem}};

                OpenApp.updateApp(params).then(function (data) {
                    if (data && data.resultCode == 0) {
                        defer.resolve();
                    } else {
                        defer.reject();
                    }
                }).catch(function (data) {
                    defer.reject();
                });
                return defer.promise;
            }

            //添加app应用类型的方法
            function addAppFun(params, UserInfoPreload, modelParam, Model, flag) {
                var defer = $q.defer();
                var product = {};
                OpenApp.addApp(params).then(function (res) {
                    if (res && res.appID) {
                        if (flag) {
                            ngDialog.close();
                        }
                        product.prodID = res.appID;
                        product.prodName = angular.fromJson(params.request).appName;

                        //如果是服务器应用和H5应用则需要上传ICon图标 修改 ：增加ios应用需要修改图标
                        if (angular.fromJson(params.request).prodType == 22 || angular.fromJson(params.request).prodType == 7 || (angular.fromJson(params.request).prodType == 19 && angular.fromJson(params.request).freeInstallType == 2)) {
                            var gAppInfo = {};
                            gAppInfo.appID = res.appID;
                            gAppInfo.prodType = angular.fromJson(params.request).prodType;
                            gAppInfo.languages = [{
                                language: angular.fromJson(params.request).defaultLang,
                                appName: angular.fromJson(params.request).appName,
                                appIcon: Model.appIcon ? (sysParamCfg.switchConf.isAgcSupportIcon ? Model.appIcon : Model.appIcon.substr(Model.appIcon.indexOf("/app/"))) : ''
                            }];

                            updateAPP(gAppInfo, modelParam.serviceItem).then(function () {
                                addservice(res);
                            })
                        } else {
                            addservice(res);
                        }
                    } else {
                        defer.resolve();
                        auiDialog.fail('新建产品失败,请稍后重试');
                    }
                }).catch(function (data) {
                    defer.reject();
                });

                function addservice(res) {

                    if (AUI.BaseJSUtil.contains(needAutoAddSerMap, modelParam.serviceItem)) {
                        addService(res.appID, angular.fromJson(params.request).prodType, modelParam.serviceItem).then(function (data) {

                            //新建应用自动刚添加服务，把服务号放进product，方便传递
                            product.srvSerialNo = data.srvSerialNo;

                            if (data && UserInfoPreload.userType == 2 && angular.fromJson(params.request).prodType == 1 && angular.fromJson(params.request).parentType == 2 && modelParam.serviceItem != 52) {
                                checkIsSignGameAgree().then(function (resp) {
                                    if (resp) {
                                        addService(res.appID, angular.fromJson(params.request).prodType, 52).then(function (rest) {
                                            defer.resolve(product);
                                        }).catch(function () {
                                            defer.reject();
                                        });
                                    } else {
                                        defer.resolve(product);
                                    }
                                });
                            } else {
                                defer.resolve(product);
                            }
                        }).catch(function () {
                            defer.reject();
                        });
                    } else {
                        if (UserInfoPreload.userType == 2 && angular.fromJson(params.request).prodType == 1 && angular.fromJson(params.request).parentType == 2 && modelParam.serviceItem != 52 && modelParam.serviceItem != 59) {
                            checkIsSignGameAgree().then(function (resp) {
                                if (resp) {
                                    addService(res.appID, angular.fromJson(params.request).prodType, 52).then(function () {
                                        defer.resolve(product);
                                    }).catch(function (data) {
                                        defer.reject(data);
                                    });
                                } else {
                                    defer.resolve(product);
                                }
                            });
                        } else {
                            defer.resolve(product);
                        }
                    }
                }

                return defer.promise;
            }

            //检查是否签署过一下游戏的协议
            function checkIsSignGameAgree() {
                var defer = $q.defer();
                var signedAgreeList = [];
                auiAgreementHelper.queryAgreements(mainCons.appConstant.serviceItemToAgreementType[52]).then(function (signInfo) {
                    if (signInfo && signInfo.signInfoList && signInfo.signInfoList.length > 0) {
                        signInfo.signInfoList.forEach(function (signInfo) {
                            //此处只有都签署过最新的才添加游戏服务
                            if (signInfo.signStatus == 1) {
                                signedAgreeList.push(signInfo.agrType);
                            }
                        });
                        defer.resolve(signedAgreeList.length == mainCons.appConstant.serviceItemToAgreement[52].length);
                    } else {
                        defer.resolve(false);
                    }
                });
                return defer.promise;
            }


            //调用openAPP接口GOpenApp.Developer.addService
            function addService(appID, prodType, serviceItem) {
                var defer = $q.defer();
                param = {};
                param.request = {
                    prodID: appID,
                    prodType: prodType,
                    serviceItem: serviceItem
                };
                OpenApp.addService(param).then(function (data) {
                    if (data && data.resultCode == 0) {
                        defer.resolve(data);
                    } else {
                        defer.resolve(data);
                    }
                }).catch(function (data) {
                    defer.reject();
                });
                return defer.promise;
            }

            //检查包的版本号
            function checkPackageNumber(selected, product, packageList) {
                var defer = $q.defer();
                getOnlinePkgVersion(product).then(function (res) {
                    if (res && selected && selected.prodID && (selected.pkgVersion || selected.rpkID) && packageList && product && product.serviceSingle && packageList.length > 0 && AUI.BaseJSUtil.contains([101, 300, 301], product.serviceSingle.serviceState)) {
                        var selectedCode;
                        var onLineCode;
                        packageList.forEach(function (package) {
                            if ((package.pkgVersion && package.pkgVersion == selected.pkgVersion) || (package.rpkID && package.rpkID == selected.rpkID)) {
                                selectedCode = package.versionCode || package.fontVsn;
                            }
                            if ((package.pkgVersion && package.pkgVersion == res.serviceInfo.pkgVersion) || (package.rpkID && package.rpkID == res.serviceInfo.rpkID)) {
                                onLineCode = package.versionCode || package.fontVsn;
                            }
                        });
                        if (selectedCode && onLineCode) {
                            var versionDiff = validPkgVersion(selectedCode, onLineCode);
                            if (versionDiff < 0) {
                                defer.resolve(false);
                                auiDialog.warn('当前选中的应用包版本号过低，请重新选择。');
                            } else if (versionDiff == 0) {
                                auiDialog.confirm('当前选择版本号与已上架版本号相同，确认继续操作?', function () {
                                    defer.resolve(true);
                                }, function () {
                                    defer.resolve(false);
                                });
                            } else {
                                defer.resolve(true);
                            }
                        } else {
                            defer.resolve(true);
                        }
                    } else {
                        defer.resolve(true);
                    }
                }).catch(function () {
                    defer.resolve(false);
                });
                return defer.promise;
            }

            /**
             * 校验升级版本号
             * @param selectedCode
             * @param onLineCode
             * @returns {boolean}
             */
            function validPkgVersion(selectedCode, onLineCode) {
                if (angular.isString(selectedCode) && angular.isString(onLineCode) && selectedCode.indexOf(".") != -1 && onLineCode.indexOf(".") != -1) {
                    var v1Arr = selectedCode.split(".");
                    var v2Arr = onLineCode.split(".");
                    var len = Math.max(v1Arr.length, v2Arr.length);
                    for (var i = 0; i < len; i++) {
                        var diff = parseInt(v1Arr[i] || 0) - parseInt(v2Arr[i] || 0);
                        if (diff != 0) {
                            return diff;
                        }
                    }
                    return 0;
                } else {
                    return parseInt(selectedCode) - parseInt(onLineCode);
                }
            }

            function getOnlinePkgVersion(product) {
                var defer = $q.defer();
                if (product.serviceSingle && product.serviceSingle.lastSrvSerialNo && product.serviceSingle.lastSrvSerialNo != '-1') {
                    OpenApp.getServiceInfo({
                        request: {
                            srvSerialNo: product.serviceSingle.lastSrvSerialNo,
                            serviceItem: product.serviceSingle.serviceItem
                        }
                    }).then(function (res) {
                        defer.resolve(res);
                    }).catch(function () {
                        defer.reject(false);
                    })
                } else {
                    defer.resolve(false);
                }
                return defer.promise;
            }

            function addCurrService(appID, prodType, serviceItem, Model) {
                var defer = $q.defer();
                isHasService(appID, serviceItem).then(function (res) {
                    if (res) {
                        updateNextStep(Model).then(function () {
                            defer.resolve(res);
                        }).catch(function () {
                            defer.resolve(res);
                        });
                    } else {
                        addService(appID, prodType, serviceItem).then(function (res) {
                            updateNextStep(Model).then(function (data) {
                                defer.resolve(res);
                            }).catch(function () {
                                defer.resolve(res);
                            });
                        }).catch(function (data) {
                            defer.reject();
                        });
                    }
                });
                return defer.promise;
            }

            function updateNextStep(Model) {
                var defer = $q.defer();
                var ModelTemp = angular.copy(Model);
                if (ModelTemp.selected.webAppUrl) {
                    var params = {request: {appInfo: {}, serviceItem: ModelTemp.serviceItem}};
                    params.request.appInfo.webAppUrl = ModelTemp.selected.webAppUrl;
                    params.request.appInfo.appID = ModelTemp.selected.prodID;
                    OpenApp.updateApp(params).then(function (data) {
                        if (data && data.resultCode === 0) {
                            var params = {
                                request: {
                                    prodID: ModelTemp.selected.prodID,
                                    serviceItem: ModelTemp.serviceItem,
                                    prodType: (ModelTemp.product.prodType + '').indexOf('-') > -1 ? ModelTemp.product.prodType.split('-')[0] : ModelTemp.product.prodType
                                }
                            };
                            if (Model.product && Model.product.serviceSingle && Model.product.serviceSingle.serviceAttrs) {
                                opeartServiceSingle(Model, params);
                            }
                            OpenApp.updateService(params, true).then(function () {
                                defer.resolve();
                            }).catch(function () {
                                defer.resolve();
                            });
                        }
                    }).catch(function () {
                        defer.reject();
                    });
                } else if (ModelTemp.selected.package) {
                    var params2 = {
                        request: {
                            prodID: ModelTemp.selected.prodID,
                            serviceItem: ModelTemp.serviceItem,
                            prodType: (ModelTemp.product.prodType + '').indexOf('-') > -1 ? ModelTemp.product.prodType.split('-')[0] : ModelTemp.product.prodType
                        }
                    };
                    if (Model.product && Model.product.serviceSingle && Model.product.serviceSingle.serviceAttrs) {
                        opeartServiceSingle(Model);
                        params2.request.serviceAttrs = Model.product.serviceSingle.serviceAttrs;
                    }
                    if (ModelTemp.selected.package.pkgVersion) {
                        params2.request.pkgVersion = ModelTemp.selected.package.pkgVersion;
                    }
                    if (ModelTemp.selected.package.rpkID) {
                        params2.request.rpkID = ModelTemp.selected.package.rpkID;
                    }
                    OpenApp.updateService(params2, true).then(function () {
                        defer.resolve();
                    }).catch(function () {
                        defer.resolve();
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;

            }

            //C处理服务属性，删除版权审核意见
            function opeartServiceSingle(Model) {
                try {
                    var serviceAttrs = JSON.parse(Model.product.serviceSingle.serviceAttrs);
                    delete serviceAttrs.certificateState;
                    delete serviceAttrs.certificateAuditIdea;
                    delete serviceAttrs.publicationState;
                    delete serviceAttrs.publicationAuditIdea;
                    delete serviceAttrs.cultureRecordState;
                    delete serviceAttrs.cultureRecordAuditIdea;
                    Model.product.serviceSingle.serviceAttrs = angular.toJson(serviceAttrs);
                } catch (e) {
                }
            }

            //判断是否有当前服务
            function isHasService(appID, serviceItem) {
                var defer = $q.defer();
                var flag;
                OpenApp.getProductByID({request: {prodID: [appID]}}).then(function (data) {
                    var productList = data.productList[0];
                    if (productList && productList.serviceList && productList.serviceList.length > 0) {
                        for (var i in productList.serviceList) {
                            if (productList.serviceList[i].serviceItem == serviceItem) {
                                flag = true;
                                break;
                            } else {
                                flag = false;
                            }
                        }
                        defer.resolve(flag);
                    } else {
                        defer.resolve(false);
                    }
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }


            return {
                getPackageList: getPackageList,
                nextStep: nextStep,
                newProduct: newProduct,
                checkPackageNumber: checkPackageNumber,
                addCurrService: addCurrService
            }

        }
    ]);
});

